import { PiCalendar, PiClockCounterClockwise } from 'react-icons/pi';
import React, { useEffect } from 'react';
import { DateRange } from 'react-day-picker';
import { DateTimePickerWithRange } from './DateTimeRangePicker';
import { Tooltip, TooltipContent, TooltipTrigger } from './Tooltip';
import { Button } from './Button';

interface TraillingDateTimePickerWithRangeProps {
  date: DateRange | undefined;
  setDate: React.Dispatch<React.SetStateAction<DateRange | undefined>>;
  timeZone: string;
  dateTimeFormat: string;
  entity: string;
  isTrailing: boolean;
  setIsTrailing: React.Dispatch<React.SetStateAction<boolean>>;
  lookBackTimeInMinutes?: number;
}

const TrailingDateTimePickerWithRange = ({
  date,
  setDate,
  timeZone,
  dateTimeFormat,
  entity,
  isTrailing,
  setIsTrailing,
  lookBackTimeInMinutes = 60,
}: TraillingDateTimePickerWithRangeProps) => {
  useEffect(() => {
    let intervalId: NodeJS.Timeout | undefined;
    if (isTrailing) {
      // Update immediately when trailing is enabled
      const updateDate = () => {
        const now = new Date();
        const from = new Date(now.getTime() - lookBackTimeInMinutes * 60 * 1000);
        setDate({ from, to: now });
      };

      updateDate(); // Update immediately
      intervalId = setInterval(updateDate, 5000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isTrailing, setDate, lookBackTimeInMinutes]);

  return (
    <div className="flex space-x-2">
      <DateTimePickerWithRange
        className="w-full"
        date={date}
        setDate={setDate}
        timeZone={timeZone}
        dateTimeFormat={dateTimeFormat}
        dateLimit="past"
        disabled={isTrailing}
      ></DateTimePickerWithRange>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            size="icon"
            variant="outline"
            onClick={() => setIsTrailing((prev: boolean) => !prev)}
          >
            {!isTrailing && (
              <PiClockCounterClockwise className="size-5"></PiClockCounterClockwise>
            )}
            {isTrailing && <PiCalendar className="size-5"></PiCalendar>}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          {isTrailing
            ? `Show ${entity}s in period`
            : `Trail ${entity}s, so that new ${entity}s will pop up`}
        </TooltipContent>
      </Tooltip>
    </div>
  );
};

export { TrailingDateTimePickerWithRange };
